fragment CampaignGridFragment on campaignGrid_Entry {
  typeHandle
  heading
  body
  backgroundGray
  grid: storyBlocksGrid {
    ... on storyBlocksGridBlock_Entry {
      id
      image {
        url
        title
      }
      heading
      body
    }
  }
}
